import Logo from './assets/logo.svg'

interface SimpleMCLogoProps {
  color?: 'primary' | 'light'
}

export const SimpleMCLogo = ({ color = 'light' }: SimpleMCLogoProps) => (
  <div className='d-flex'>
    <Logo className={`mc-icon mc-icon--4 mc-text-color--${color}`} />
  </div>
)
